export default [
  {
    path: '/apps/transportadora/list',
    name: 'apps-transportadora-list',
    component: () => import('@/views/cadastros/info-organizacionais/transportadora/list/Index.vue'),
    meta: {
      pageTitle: 'Transportadora',
    },
  },
];
